import type { UserMinDTO } from '@/composables/user/users'
import { CommonResponse, ARTICLE_GET_BY_ID, ARTICLE_OPEN, ARTICLE_PUBLISH, netClient } from '@/apis/api'

/**
 * 投稿文章返回结果 (ArticleDTO)
 */
export interface ArticleDTO {
  /** 文章id */
  id?: string
  /** 文章标题 */
  title?: string
  /** 文章内容文本 */
  contentTxt?: string
  /** 作者名称 */
  author?: string
  /** 作者ID */
  authorId?: string
  /** 标签 */
  tags?: string
  /** 缩略图id */
  thumbnailId?: string
  /** 缩略图信息 */
  thumbnail?: FileDTO // FileDTO
  thumbnailUrl: string
  /** 是否已发布 */
  published?: boolean
  /** 分享内容 */
  shareContent?: string
  /** 审核员id */
  auditerId?: string
  /** life id */
  lifeId?: string
  /** 审核状态 0 - 待审核 1 - 已通过 2 - 未通过 */
  auditStatus?: number
  /** 阅读数量 */
  read?: number
  /** 作者用户信息 */
  authorUser?: Record<string, any> // UserMinDTO
  /** 创建时间 (Unix时间戳, 秒/毫秒由全局配置决定) */
  createdAt?: number
}

export function getArticleById(id: string) {
  return netClient.request<CommonResponse<ArticleDTO>>(ARTICLE_GET_BY_ID.replace('{id}', id), 'get', {})
}

// GET /v1/article/open?page=12&pageSize=100
export interface GetArticleResponse {
  page: number
  pageSize: number
  total: number
  articleDTOList: ArticleDTO[]
}

export function getArticleOpen(page: number, pageSize: number) {
  return netClient.request<CommonResponse<GetArticleResponse>>(ARTICLE_OPEN, 'get', { page, pageSize })
}

export interface PublishArticleCommand {
  /**
   * 原稿件ID (MemorialArticle.id)
   * @required true
   */
  memorialArticleId: string

  /**
   * 文章标题
   * @required true
   */
  title: string

  /**
   * 分享文字
   * @required true
   */
  shareContent: string

  author: string

  /**
   * 文章缩略图Url (imageUrl)
   * @required true
   */
  imageUrl: string

  /**
   * 文章缩略图Id (imageId)
   * @required false
   */
  imageId?: string
}

export function publishArticle(command: PublishArticleCommand) {
  return netClient.request<CommonResponse<ArticleDTO>>(ARTICLE_PUBLISH, 'post', command)
}
